import React, {Fragment, useEffect, useState} from "react";


import clientconfigwebapp, {
    check_login_appbk, empty_bk, modal_login_reg_all_hide, modal_login_reg_bk_show, scrollTo_uphk, Token_get_appbk
} from "../../clientconfigwebapp";

import Modal_Login_reg from "../../components/Modal_Login_reg/Modal_Login_reg";
import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import {toast, ToastContainer} from "react-toastify";
import {useLocation, useParams} from "react-router-dom";
import axios from "axios";


function useQuery() {
    const { search } = useLocation();
    console.log(search)
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Index_Login_Register = (props) => {

    const {type_user_login_reg} = useParams();
    let query_url_get = useQuery();

    const [data_category_box, set_data_category_box] = useState([]);
    const [redirect_url_val, set_redirect_url] = useState('');

    
    useEffect(() => {


        set_redirect_url(query_url_get.get('redirect'));

        scrollTo_uphk();
        Load_api_page();
        localStorage.clear();
        modal_login_reg_bk_show("login_reg_check_view_modal");




    }, [1]);



    const Handle_login_register_closeall = () => {
        modal_login_reg_all_hide();
    };

    const Load_api_page= () => {

        var config = null;

        if(check_login_appbk()==true){
            config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };
        }

        set_data_category_box([]);

        axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/` ,null,config)
            .then((res) => {


                if(String(res.data).length > 0) {


                    if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }



                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{

            toast.error('خطای اتصال به سرور کد 3455345', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });


    }

    return (
        <Fragment>


            <style jsx>{`


                .body,.App {
                    background: #374151;
                }
              
                
                

                .container-top-header-loginreg {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-content: center;
                    justify-content: center;
                    align-items: center;
                    padding-top: 41px;
                    border-bottom: solid 1px #8bc5e23d;
                    padding-bottom: 40px;
                }

                .MuiInputLabel-root {
                    font-size: 18px;
                    background-color: white;
                    padding-right: 10px;
                    color: black;
                }

                @media only screen and (max-width: 768px) {


                    .title_main {
                        font-size: 29px !important;
                    }

                    .sub_title_main {
                        font-size: 17px !important;
                    }


                    .MuiInputLabel-root {
                        color: black;
                        font-size: 16px;
                        background-color: white;
                        padding-right: 10px;
                    }

                    .MuiTextField-root input {
                        font-size: 13px !important;
                    }

                    

                }

            `}</style>


            <div className="container">
                <ToastContainer/>
                <div className="fullbox_reg_login modal_animation_bk_2" id={"login_reg_view_modal"}
                     style={{"display": "block"}}>


                                <Modal_Login_reg redirectURL={redirect_url_val}  data_category_box={data_category_box} />


                </div>


            </div>


        </Fragment>
    );
}

export default Index_Login_Register;